/**
 * Shared loading skeleton for ALM analysis pages.
 *
 * Renders while the initial "latest result" query is in-flight.
 * Matches the rough layout of the tile + table combo used by NIM,
 * Duration, EVE, LCR, FTP, etc. so the page doesn't flash blank.
 */
export function AnalysisSkeleton() {
  return (
    <div className="space-y-6 animate-pulse" aria-hidden="true">
      {/* Metric tiles row */}
      <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="rounded-xl border bg-card p-5 space-y-3">
            <div className="h-3 w-24 rounded bg-muted" />
            <div className="h-8 w-20 rounded bg-muted" />
            <div className="h-3 w-32 rounded bg-muted" />
          </div>
        ))}
      </div>

      {/* Table / chart placeholder */}
      <div className="rounded-xl border bg-card">
        <div className="border-b px-6 py-4">
          <div className="h-4 w-40 rounded bg-muted" />
        </div>
        <div className="divide-y">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="flex items-center gap-4 px-6 py-3">
              <div className="h-3 w-28 rounded bg-muted" />
              <div className="ml-auto h-3 w-16 rounded bg-muted" />
              <div className="h-3 w-16 rounded bg-muted" />
              <div className="h-3 w-16 rounded bg-muted" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
